import { render, staticRenderFns } from "./TrainingEditTabQuestion.vue?vue&type=template&id=a7cda126&"
import script from "./TrainingEditTabQuestion.vue?vue&type=script&lang=js&"
export * from "./TrainingEditTabQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports